export const X_DEVICE_DESKTOP = 'desktop-admin'
